import { render, staticRenderFns } from "./Fornitori.vue?vue&type=template&id=fc2714ce"
import script from "./Fornitori.vue?vue&type=script&lang=js"
export * from "./Fornitori.vue?vue&type=script&lang=js"
import style0 from "./Fornitori.vue?vue&type=style&index=0&id=fc2714ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports